export const TRACKING_STATE_STORAGE_NAME = 'trackingState';

//# sourceMappingURL=tracker.config.js.map